<div class="u-flex-full">
  <label>{{value?.identifier}} - {{value?.threat}}</label>
  <button class="close" *ngIf="value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
    (click)="clearRisk()">
    <mat-icon>close</mat-icon>
  </button>
</div>
